import { render, staticRenderFns } from "./HearingDocumentsMotionAppApplyLeavePg.vue?vue&type=template&id=20c909f4&scoped=true"
import script from "./HearingDocumentsMotionAppApplyLeavePg.vue?vue&type=script&lang=ts"
export * from "./HearingDocumentsMotionAppApplyLeavePg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c909f4",
  null
  
)

export default component.exports